import React, { useEffect, useState } from 'react';
// Material UI :
import { Box, IconButton, Modal, Tooltip } from '@mui/material';
// Icons :
import { AiOutlineEdit } from 'react-icons/ai';
// Toast :
import { toast } from 'sonner';
// import 'react-toastify/dist/ReactToastify.css';
// Functions :
import { editAgent } from '../../config/agentsConfig';
// Assets : 
import Loading from '../../assets/images/white-loading.gif';
import { getGroups } from '../../config/groups';
// React-select :
import Select from 'react-select';

export const EditAgentModal = ({ agentId, name, cin, cnss, email, phone, pricePerDay, groupId, onEdit, page, searchQuery }) => {
    const [agentName, setAgentName] = useState('');
    const [agentCin, setAgentCin] = useState('');
    const [agentCnss, setAgentCnss] = useState('');
    const [agentEmail, setAgentEmail] = useState('');
    const [agentPhone, setAgentPhone] = useState('');
    const [agentPricePerDay, setAgentPricePerDay] = useState('');
    const [agentGroupId, setAgentGroupId] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const [groups, setGroups] = useState([]);

    const fillData = () => {
        setAgentName(name);
        setAgentCin(cin);
        setAgentCnss(cnss);
        setAgentEmail(email);
        setAgentPhone(phone);
        setAgentPricePerDay(pricePerDay);
        setAgentGroupId(groupId);
    };

    // ? ===============================|| Modal Style ||===============================
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [width, setWidth] = useState('50%');
    const [padding, setPadding] = useState(3);

    const currentWidth = window.innerWidth;

    useEffect(() => {
        if (currentWidth <= 500) {
            setWidth('90%');
            setPadding(2);
        }
    }, [currentWidth]);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: width,
        maxHeight: '95vh',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: padding,
        borderRadius: 3,
        overflowY: 'scroll'
    };
    // ? ===============================================================================

    // ? ===============================|| Toast ||===============================
    // const notifySuccess = (message) => toast.success(message, {
    //     position: "top-right",
    //     autoClose: 2000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: false,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    // });
    // const notifyError = (message) => toast.error(message, {
    //     position: "top-right",
    //     autoClose: 2000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: false,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    // });
    // const notifyInfo = (message) => toast.info(message, {
    //     position: "top-right",
    //     autoClose: 2000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: false,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    // });
    // ? ===============================================================================

    // ? ===============================|| Edit Agent ||================================
    const handleEditAgent = async () => {
        try {
            setIsLoading(true);
            if (agentName !== '' && agentEmail !== '') {
                const result = await editAgent(agentId, agentName, agentCin, agentCnss, agentPhone, agentPricePerDay, agentGroupId);
                if (result === 'Changed') {
                    onEdit(); // Refresh table after adding an affair.
                    // notifySuccess('Agent modifié avec succès');
                    toast.success('Agent modifié avec succès');
                    handleClose();
                    setIsLoading(false);
                }
                else if (result === 'notChanged') {
                    // notifyError('Veuillez réessayer');
                    toast.warning('Il y a un problème, veuillez réessayer !')
                    handleClose();
                    setIsLoading(false);
                }
            } else {
                setIsLoading(false);
                // handleClose();
                // notifyInfo('Veuillez remplir le formulaire');
                toast.info('Veuillez remplir le formulaire !')
            }
        } catch (error) {
            // notifyError('Veuillez réessayer');
            toast.warning('Il y a un problème, veuillez réessayer !')
            handleClose();
            setIsLoading(false);
        }
    };
    // ? ===============================================================================

    // ? ============================|| Handle Enter Click ||===========================
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleEditAgent();
        }
    };
    // ? ===============================================================================

    // ? ====================|| Refresh data when : Page Change ||======================
    useEffect(() => {
        fillData();
    }, [page, searchQuery]);
    // ? ===============================================================================

    // ? =============================|| get the shortName ||===========================
    useEffect(() => {
        const handleGetGroups = async () => {
            const result = await getGroups();
            setGroups(result);
        };

        handleGetGroups();
    }, []);
    // ? ===============================================================================

    return (
        <div>
            <Tooltip title="Modifier" onClick={handleOpen}>
                <IconButton>
                    <AiOutlineEdit size={20} color='green' />
                </IconButton>
            </Tooltip>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <p className='text-3xl font-bold'>Modifier Agent</p>
                    <div className='mt-10'>
                        {/* Full Name */}
                        <div className='mb-4'>
                            <p className='font-medium mb-2'>Nom et prénom</p>
                            <input
                                type='text'
                                placeholder='eg: Nom et prénom'
                                className='border border-gray w-full rounded-md py-2 px-3'
                                value={agentName}
                                onChange={e => setAgentName(e.target.value)}
                                onKeyPress={handleKeyPress}
                                required
                            />
                        </div>

                        {/* CIN */}
                        <div className='mb-4'>
                            <p className='font-medium mb-2'>CIN</p>
                            <input
                                type='text'
                                placeholder='eg: J000000'
                                className='border border-gray w-full rounded-md py-2 px-3'
                                value={agentCin}
                                onChange={e => setAgentCin(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                        </div>

                        {/* Code CNSS */}
                        <div className='mb-4'>
                            <p className='font-medium mb-2'>Code CNSS</p>
                            <input
                                type='text'
                                placeholder="eg: XXXX XXXX XXXX"
                                className='border border-gray w-full rounded-md py-2 px-3'
                                value={agentCnss}
                                onChange={e => setAgentCnss(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                        </div>

                        {/* Email */}
                        <div className='mb-4'>
                            <p className='font-medium mb-2'>E-mail</p>
                            <input
                                type='text'
                                placeholder="eg: agent@pprime.ma"
                                className='border border-gray w-full rounded-md py-2 px-3'
                                value={agentEmail}
                                onChange={e => setAgentEmail(e.target.value)}
                                onKeyPress={handleKeyPress}
                                disabled
                            />
                        </div>

                        {/* Téléphone */}
                        <div className='mb-4'>
                            <p className='font-medium mb-2'>Téléphone</p>
                            <input
                                type='text'
                                placeholder="eg: 06 01 02 03 04"
                                className='border border-gray w-full rounded-md py-2 px-3'
                                value={agentPhone}
                                onChange={e => setAgentPhone(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                        </div>

                        {/* Price Per Day */}
                        <div className='mb-4'>
                            <p className='font-medium mb-2'>Prix par jour</p>
                            <input
                                type='number'
                                placeholder="eg: 120 Dh"
                                className='border border-gray w-full rounded-md py-2 px-3'
                                value={agentPricePerDay}
                                onChange={e => setAgentPricePerDay(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                        </div>

                        {/* Group ID */}
                        <div className='mb-8'>
                            <p className='font-medium mb-2'>Groupe</p>
                            {/* <select
                                className='border border-gray w-full rounded-md py-2 px-3'
                                value={agentGroupId}
                                onChange={e => setAgentGroupId(e.target.value)}
                            >
                                <option value='' className='text-gray'>Pas maintenant</option>
                                {
                                    groups?.map((group, i) => (
                                        <option key={i} value={group?.value}>{group?.label}</option>
                                    ))
                                }
                            </select> */}
                            <Select
                                options={[
                                    { value: '', label: 'Pas maintenant', className: 'text-gray' },
                                    ...groups?.map((group, i) => ({
                                        value: group?.value,
                                        label: group?.label
                                    }))
                                ]}
                                isSearchable={false}
                                value={groups.find(group => group.value === agentGroupId) || ''}
                                onChange={(selectedOption) => setAgentGroupId(selectedOption.value)}
                            />
                        </div>

                        {/* Buttons */}
                        <div className='flex justify-end items-center'>
                            <button
                                onClick={handleClose}
                                className='border border-gray rounded-md py-2 px-4 mr-4'
                            >
                                Annuler
                            </button>
                            <button
                                onClick={() => handleEditAgent()}
                                className='bg-primary text-white rounded-md py-2 px-4'
                            >
                                {
                                    isLoading ? <img src={Loading} alt='' className='w-6' /> : <p>Modifier</p>
                                }
                            </button>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}